import {initScroll} from "./scroll";
require('./alpine');

window.onload = () => initScroll();
